/**
 * useCsdnLogin
 *
 * @desc 描述：CSDN OAuth 2.0 认证
 * @desc 描述：因为临时协助，整体思路最小入侵现有代码
 */

/* =================================================== */

import { useEffect, useMemo } from "react";
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";
import Qs from "qs";

// CSDN 跳转过来地址，存储在 Storage 的 Key
const CSDNStorageKey = "_CSDNStorageKey_";
const AuthCsdnSearch = {
  response_type: "code",
  scope: "openid profile email phone offline_access",
};

export const useCsdnLogin = () => {
  const csdn = (global || window)._AUTHING__GLOBAL_CONFIG_?.csdn ?? {};
  const { auth_csdn_url, ..._csdnObj } = csdn;
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const { pathname } = useLocation();

  const csdnCfg = useMemo(
    () => ({
      // 是否跳转 CSDN 认证
      isToCsdn: csdn && search.get("login") === "from_csdn",

      // CSDN 认证地址
      toCsdnUrl: `${auth_csdn_url}?${Qs.stringify({
        ...AuthCsdnSearch,
        ..._csdnObj,
      })}`,
    }),
    []
  );

  // 存储 CSDN 目标地址，需求：完成授权后页面要在目标地址上
  useEffect(() => {
    const savePathname = sessionStorage.getItem(CSDNStorageKey);

    if (csdnCfg.isToCsdn)
      return void sessionStorage.setItem(CSDNStorageKey, pathname);

    if (savePathname) {
      sessionStorage.removeItem(CSDNStorageKey);

      // 当前地址与存储地址不同时，才重定向
      if (pathname !== savePathname) navigate(savePathname, { replace: true });
    }
  }, []);

  return csdnCfg;
};
